



























































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { Account, SearchCondition } from '@/modules/admin/account';
import { ElForm } from 'element-ui/types/form';
import { UserTypes } from '@/enums/userTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import store from '@/store';

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component
export default class UserList extends Vue {
  private editVisible = false;
  private isEdit = false;
  private showSearchCondition = true;

  private formRule = {
    lastName: [
      { required: true, message: '氏名（姓）を入力してください' },
    ],
    firstName: [
      { required: true, message: '氏名（名）を入力してください' },
    ],
    lastNameKana: [
      { required: true, message: 'カナ（姓）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
    firstNameKana: [
      { required: true, message: 'カナ（名）を入力してください' },
      { pattern: '^[ァ-ヶー]*$', trigger: 'blur', message: '全角カタカナを入力してください' },
    ],
  };

  private deleteFormRule = {
    checkUserName: [
      { required: true, message: '削除する管理者名を入力してください' },
      { validator: this.validateCheckUserName, trigger: 'blur' },
    ],
  };

  private validateCheckUserName(rule: any, value: string, callback: any) {
    const userName = ((this.$refs.userDelete as DialogWrapper).form as any).userName;
    if (value.replace(/\s+/g, '') === userName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('管理者名が異なります'));
    }
  }

  get accountId(): string {
    return this.$store.getters['adminAuth/accountId'];
  }

  get loading(): boolean {
    return this.$store.state.adminAccount.loading;
  }

  get countAll(): number {
    if (this.$store.state.adminAccount.countAll === 0) {
      return 1;
    } else {
    return this.$store.state.adminAccount.countAll;
    }
  }

  get users(): Account[] {
    return this.$store.state.adminAccount.users;
  }

  get condition(): SearchCondition {
    return this.$store.state.adminAccount.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['adminAuth/userType']) {
      case UserTypes.Admin:
        next();
        break;
      default:
        next({ name: 'AdminError' });
        break;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('adminAccount/searchUsers', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private submitForm() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.userEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onCreate() {
    this.isEdit = false;

    const form: Account = {
      id: '',
      userId: '',
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      authority: 0,
      schoolId: '',
      schoolName: '',
      availableFunctionbit: 0,
      availableFunctionTypes: new Array<FunctionTypes>(),
    };

    let result: Account;
    try {
      result = await (this.$refs.userEdit as DialogWrapper).open({...form}) as Account;
    } catch (error) {
      return;
    }

    const fullName = this.getFullName(result);
    try {
      const createResult = await this.$store.dispatch('adminAccount/createUser', result);
      createResult.title = '管理者登録完了';
      try {
        await (this.$refs.userCreateResult as DialogWrapper).open({...createResult});
      } catch (error) {
        return;
      }
    } catch (error) {
      this.$notify.error({
        title: '管理者登録エラー',
        message: error.message,
        position: 'bottom-right'
      });
      return;
    }

    this.loadData();
  }

  private async onEdit(row: Account) {
    this.isEdit = true;

    let form: Account;
    try {
      form = await this.$store.dispatch('adminAccount/getUser', row.id);
    } catch (error) {
      form = JSON.parse(JSON.stringify(row));
    }

    let result: Account;
    try {
      result = await (this.$refs.userEdit as DialogWrapper).open({...form}) as Account;
    } catch (error) {
      return;
    }

    const fullName = this.getFullName(row);
    try {
      await this.$store.dispatch('adminAccount/editUser', result);
      this.$notify({
        title: '管理者変更完了',
        message: `「${fullName}」を変更しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: '管理者変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.userDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onDelete(row: Account) {
    const fullName = this.getFullName(row);

    try {
      const form = {
        userName: fullName,
        checkUserName: '',
      };
      await (this.$refs.userDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('adminAccount/deleteUser', row.id);
      this.$notify({
        title: '管理者削除完了',
        message: `「${fullName}」を削除しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: '管理者削除エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async onResetPassword(row: Account) {
    const fullName = this.getFullName(row);
    try {
      await this.$confirm(`「${fullName}」のパスワードを初期化します。よろしいですか？`, '管理者パスワード初期化', {
        confirmButtonText: '初期化',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      });
    } catch (error) {
      return;
    }

    try {
      const result = await this.$store.dispatch('adminAccount/resetPassword', row.id);
      result.title = 'パスワード初期化完了';

      try {
        await (this.$refs.userCreateResult as DialogWrapper).open({...result});
      } catch (error) {
        return;
      }
    } catch (error) {
      this.$notify.error({
        title: '管理者パスワード初期化エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private getFullName(user: Account) {
    return `${user.lastName}　${user.firstName}`;
  }
}
